import {
  InputBase as MuiInputBase,
  InputBaseProps as MuiInputBaseProps,
  inputBaseClasses,
} from '@mui/material'
import styled from 'styled-components'

export { inputBaseClasses }
export type InputBasePropsType = MuiInputBaseProps

const InputBase = styled(MuiInputBase)<InputBasePropsType>``

export default InputBase
